import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const RestroomIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M40 65C48.2842 65 55 58.2842 55 50C55 41.7158 48.2842 35 40 35C31.7158 35 25 41.7158 25 50C25 58.2842 31.7158 65 40 65Z"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M40.035 129.828C20 129.828 20 79.8282 20 79.8282H60C60 79.8282 60 129.828 39.965 129.828H40.035Z"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M120 65C128.284 65 135 58.2842 135 50C135 41.7158 128.284 35 120 35C111.716 35 105 41.7158 105 50C105 58.2842 111.716 65 120 65Z"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M119.965 79.8282C140 79.8282 140 129.828 140 129.828H100C100 129.828 100 79.8282 120.035 79.8282H119.965Z"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M80 130V30" stroke={color} strokeWidth="6" strokeLinecap="round" />
        </svg>
    );
};
